export const appName = process.env.VUE_APP_NAME || 'malo-mahuzier'
